import { render, staticRenderFns } from "./application.vue?vue&type=template&id=451c5ec8"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"
import style0 from "./application.vue?vue&type=style&index=0&id=451c5ec8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451c5ec8')) {
      api.createRecord('451c5ec8', component.options)
    } else {
      api.reload('451c5ec8', component.options)
    }
    module.hot.accept("./application.vue?vue&type=template&id=451c5ec8", function () {
      api.rerender('451c5ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/application.vue"
export default component.exports